import React, { useEffect } from 'react';
import _get from 'lodash/get';
import { useDispatch, useSelector } from 'react-redux';
import { selectedCitySelector } from 'selectors/app-selector';
import usePrevious from 'common/usePrevious';
import commonDuck from 'ducks/common-duck';

const SelectedCityListener = () => {
  const dispatch = useDispatch();
  const selectedCity = useSelector(selectedCitySelector);
  const countryCode = _get(selectedCity, 'countryCode');
  const cityCode = _get(selectedCity, 'cityCode');
  const cityID = _get(selectedCity, 'cityID');
  const prevCityCode = usePrevious(cityCode);
  const prevCityID = usePrevious(cityID);
  useEffect(
    () => {
      if (
        cityCode &&
        cityID &&
        (prevCityCode !== cityCode || prevCityID !== cityID)
      ) {
        dispatch(
          commonDuck.creators.fetchConfiguration(countryCode, cityCode, cityID),
        );
      }
    },
    [dispatch, countryCode, cityCode, cityID, prevCityCode, prevCityID],
  );
  return <div />;
};

export default SelectedCityListener;
